import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M3 3h18a1 1 0 011 1v16a1 1 0 01-1 1H3a1 1 0 01-1-1V4a1 1 0 011-1zm9.06 8.68L5.65 6.24l-1.3 1.52 7.72 6.56 7.58-6.56-1.3-1.52-6.29 5.44z"/>
  </SvgIcon>
);